import { ViewportExtraLarge, ViewportLarge, ViewportMedium, ViewportSmall } from './cpds-viewport';
import { VIEWPORT_SIZES, ViewportComponentType } from './types';

//Display names
export const displayNames = Object.values(VIEWPORT_SIZES);

// Subcomponent utility function to get valid media queries
export const getMediaQuery = (type: ViewportComponentType) => {
  switch (type) {
    case VIEWPORT_SIZES.sm:
      return { maxWidth: 767 };
    case VIEWPORT_SIZES.md:
      return { minWidth: 768, maxWidth: 1279 };
    case VIEWPORT_SIZES.lg:
      return { minWidth: 1280, maxWidth: 1679 };
    case VIEWPORT_SIZES.xl:
      return { minWidth: 1680 };
    default:
      return {};
  }
};

// Subcomponent utility function to get valid elements
export const getElements = (type: string) => {
  switch (type) {
    case 'ViewportSmall':
      return ViewportSmall;
    case 'ViewportMedium':
      return ViewportMedium;
    case 'ViewportLarge':
      return ViewportLarge;
    case 'ViewportExtraLarge':
      return ViewportExtraLarge;
    default:
      return null;
  }
};

// Custom type guard to check if a component is a valid Viewport child
export const isValidViewportChild = (child: any) => {
  return displayNames.includes(child.type.displayName);
};

//Check if the ViewPort sub-components are in correct order if not sort them
export const sortingLogic = (a, b) => {
    return displayNames.indexOf(a?.type?.displayName) - displayNames.indexOf(b?.type?.displayName);
  };
